// extracted by mini-css-extract-plugin
export default {"saleEndsLabel":"xsaCMx"};